import { useEffect, useState } from 'react';

// This hook checks to make sure if there is sufficient vertical space beneath the button to toggle full view of data sources
// If there is not enough space beneath, then render above.
export const usePanelPosition = (
  isExpanded: boolean,
  configMode: string | null,
  buttonRef: React.RefObject<HTMLButtonElement>
) => {
  const [panelPosition, setPanelPosition] = useState('down');

  useEffect(() => {
    // Only calculate position when panel first expands, not when configMode changes
    if (!isExpanded || configMode !== null) return;

    const updatePosition = () => {
      if (!buttonRef.current) return;
      const buttonRect = buttonRef.current.getBoundingClientRect();
      const spaceAbove = buttonRect.top;
      const spaceBelow = window.innerHeight - buttonRect.bottom;

      // Use the larger panel height for initial calculation to ensure enough space
      // This prevents the panel from needing to reposition when entering config mode
      const panelHeight = 500;

      // Add buffer space for smooth positioning and dropdown menus
      const buffer = 50;
      const requiredSpaceBelow = panelHeight + buffer;

      // Prefer showing panel below; when it doesn't fit there, take whichever
      // side has more room (the panel shrinks to fit via its max-height, so
      // the roomier side is always the right choice in short windows).
      if (spaceBelow < requiredSpaceBelow && spaceAbove > spaceBelow) {
        setPanelPosition('up');
      } else {
        setPanelPosition('down');
      }
    };

    updatePosition();
    window.addEventListener('resize', updatePosition);
    return () => window.removeEventListener('resize', updatePosition);
  }, [isExpanded, configMode, buttonRef]);

  return panelPosition;
};
